import React from "react";

import { useTranslation } from "react-i18next";
import { FrontendUserInfo } from "node-library/dist/portal";

import { getStatusColors, getStatusString } from "../../../helpers/orderHelper";
import {
	COAIcon,
	DeleteIcon,
	EditIcon,
	ViewResultIcon,
} from "../../../common-components/svgIcons";
import { NeutralColor } from "node-library/dist/colors";
import { KebabDropdownButton } from "../../../common-components/button";
import { Card } from "@mui/material";
import {
	getUserRoleString,
	getUserStatusColors,
	getUserStatusString,
} from "../../../helpers/userHelper";

import { formatCustomDate } from "node-library/dist/helpers/date_helper";
import { SystemRole } from "node-library/dist/constants";

interface Props {
	user: FrontendUserInfo;
	goToViewUserDetails: () => void;
	// discardUnstartedOrder: () => void;
}

export default function UserCell(props: Props) {
	const { t: translation } = useTranslation();

	const {
		goToViewUserDetails,
		user,
		// discardUnstartedOrder,
	} = props;

	let actionOptions: Array<{
		key: string;
		onClick: () => void;
		children: React.ReactNode;
	}>;

	const userHeaderRow: React.ReactNode = (
		<div
			style={{
				display: "flex",
				justifyContent: "space-between",
				alignItems: "center",
				gap: "5px",
			}}
		>
			{/* <div
				className="typography-caption sample-status-box"
				style={{
					backgroundColor: statusColor.backgroundColor,
					border: `1px solid ${statusColor.borderColor}`,
					color: statusColor.textColor,
				}}
			>
				{statusString}
			</div> */}

			{/* <KebabDropdownButton
				menuOptions={actionOptions}
				id={`batch-more-action-menu-${order.orderBarcodeId}`}
				onClick={(e) => {}}
			></KebabDropdownButton> */}
		</div>
	);
	const userBody: React.ReactNode = (
		<div
			style={{
				marginTop: "10px",
				display: "flex",
				flexDirection: "column",
				gap: "5px",
			}}
		>
			<div className="order-cell-body-row typography-body-02">
				<div className="sample-info-row-description">
					{translation("Username")}
				</div>
				<div className="overflow-ellipsis-text" style={{ maxWidth: "50%" }}>
					{user.userName}
				</div>
			</div>
			<div className="order-cell-body-row typography-body-02">
				<div className="sample-info-row-description">
					{translation("FirstName")}
				</div>
				<div className="overflow-ellipsis-text" style={{ maxWidth: "50%" }}>
					{user.firstName}
				</div>
			</div>
			<div className="order-cell-body-row typography-body-02">
				<div className="sample-info-row-description">
					{translation("LastName")}
				</div>
				<div className="overflow-ellipsis-text" style={{ maxWidth: "50%" }}>
					{user.lastName}
				</div>
			</div>
			<div className="order-cell-body-row typography-body-02">
				<div className="sample-info-row-description">{translation("Role")}</div>
				<div className="overflow-ellipsis-text" style={{ maxWidth: "50%" }}>
					{getUserRoleString(user.role?.roleKey as SystemRole, translation)}
				</div>
			</div>
			<div className="order-cell-body-row typography-body-02">
				<div className="sample-info-row-description">
					{translation("Locked")}
				</div>
				<div className="overflow-ellipsis-text" style={{ maxWidth: "50%" }}>
					{user.locked ? translation("Yes") : translation("No")}
				</div>
			</div>
			<div className="order-cell-body-row typography-body-02">
				<div className="sample-info-row-description">
					{translation("RegistrationTime")}
				</div>
				<div className="overflow-ellipsis-text" style={{ maxWidth: "50%" }}>
					{formatCustomDate(user.inserted as Date)}
				</div>
			</div>
			{/* <div className="order-cell-body-row typography-body-02">
				<div className="sample-info-row-description">
					{translation("Receivedon")}
				</div>
				<div className="overflow-ellipsis-text" style={{ maxWidth: "50%" }}>
					{order.registered ? formatCustomDate(order.registered) : "--"}
				</div>
			</div> */}
		</div>
	);

	return (
		<Card
			className="card-border-radius-14p card-medium-padding highlight-card"
			style={{ cursor: "pointer" }}
			key={user.userId}
			onClick={() => {
				goToViewUserDetails();
			}}
		>
			{userHeaderRow}
			{userBody}
		</Card>
	);
}
